
const industries={
"All":"Tout",
"clubs":"Clubs",
"Education":"Éducation",
"Academic":"Université",
"Business/Trade":"Affaires et commerce",
"Entertainment":"Autre",
"Arts & Cinema":"Divertissement",
"Sports & Amusements":"Sports et divertissements",
"Food & Beverage":"Nourriture et boissons",
"Casual":"Restauration décontractée",
"Fine Dining":"Restauration gastronomique",
"Quick Service":"Restauration rapide",
"Upmarket":"Restauration haut de gamme",
"Government":"Gouvernement",
"Health Care":"Soins de santé",
"Pharmacy":"Secteur pharmaceutique",
"Lodging":"Hébergement",
"Luxury":"De luxe",
"Mid Range":"Milieu de gamme",
"Premium":"De prestige",
"Standard":"Standard",
"Motor Vehicle Expenditures":"Véhicules motorisés",
"Non-Profit/Charity":"Organismes sans but lucratif et de bienfaisance",
"Oil Companies":"Compagnies pétrolières",
"Professional Services":"Services professionnels",
"Beauty":"Esthétique",
"Business":"Affaires",
"Construction":"Construction",
"Domestic":"Produits pour la maison",
"Financial and Accounting":"Finance et comptabilité",
"Insurance":"Assurances",
"Legal":"Services juridiques",
"Repair Shops":"Ateliers de réparation",
"Retail":"Vente au détail",
"Books & Home Entertainment":"Livres et divertissement à domicile",
"Catalog":"Catalogues",
"Commercial Supplies":"Approvisionnement commercial",
"Consumables":"Produits de consommation",
"Dept Store":"Grands magasins",
"Dept Store - Upmarket":"Grands magasins haut de gamme",
"Electronics":"Appareils électroniques",
"Fashion - Aspirational":"Mode haut de gamme",
"Fashion - High St":"Mode courante",
"Fashion - Jewelry":"Mode – Bijouterie",
"Fashion - Luxury":"Mode de luxe",
"Florists":"Fleuristes",
"Furniture":"Mobilier",
"Hobby":"Passe-temps",
"Home Improvement":"Rénovation",
"Miscellaneous":"Produits divers",
"Office Supplies":"Fournitures de bureau",
"Publications":"Publications",
"Recreational Goods":"Articles de loisir",
"Supermarket":"Supermarchés",
"Supermarket - Upmarket":"Supermarchés haut de gamme",
"Telecom":"Télécommunications",
"Equipment":"Équipement",
"Services":"Services",
"Transportation":"Transport",
"Travel Other":"Voyages (autre)",
"Airlines":"Sociétés aériennes",
"Car Rental":"Location de voitures",
"Travel Related":"Achats liés aux voyages",
"Other":"Autre",

}
export function industriesConvert(word) {
    return industries[word] || word;
};
